import TempNode from './TempNode.js';

class ExpressionNode extends TempNode {
  constructor() {
    let snipped = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let nodeType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'void';
    super(nodeType);
    this.snipped = snipped;
  }

  generate(builder) {
    const type = this.getNodeType(builder);
    const snipped = this.snipped;

    if (type === 'void') {
      builder.addFlowCode(snipped);
    } else {
      return `( ${snipped} )`;
    }
  }

}

export default ExpressionNode;